import React, { useRef, useState } from "react";
import { Button, Card, Divider, Tabs } from "antd";
import SoForm from "./SoForm";
import SoDetailList from "./SoDetailList";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";


export default function () {
    const history = useHistory();
    const formRef = useRef();
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
    const { closeNav } = useModelDispatchers("nav");


    const onSave = () => {
        formRef.current.insert(setSaveBtnDisabled);
    }
    const getForm = () => {
        return formRef && formRef.current ? formRef.current.form() : null
        // return formRef.current.form();
    };
    const onBack = () => {
        closeNav();
        goPage(history, "3-2");
    }
    const onRepair = () => {
        formRef.current.repair(setSaveBtnDisabled);
    }
    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">新增销售单</span>
                </h3>
                <div style={{ width: "600px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.S_AD_REPL}>
                        <Button disabled={saveBtnDisabled} danger onClick={onRepair}>补单</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.S_AD_SAVE}>
                        <Button className="margin-left-8"
                            type="primary"
                            onClick={onSave}
                            disabled={saveBtnDisabled}
                        >
                            保存
                    </Button>
                    </YhAuth>
                    <Button className="margin-left-8" onClick={onBack}>返回</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <SoForm formRef={formRef} actionType={CM_ACTION_TYPE.INSERT} />
            <Divider orientation="left" />
            <SoDetailList getForm={getForm} />
        </Card>
    );
}